import { parse } from "date-fns";
import * as Yup from "yup";

export const validationSchemaTransporter = Yup.object({
  loadingOrder: Yup.string()
    .required("Para continuar é necessário preencher este campo.")
    .test("onlyNumber", "Preencha somente com números.", (value) =>
      /^[\d]+$/.test(value)
    )
    .max(
      20,
      "Por favor, verifique se a ordem de carregamento digitada possui até 20 caracteres."
    ),
  numberTN: Yup.string()
    .required("Para continuar é necessário preencher este campo.")
    .test("onlyNumber", "Preencha somente com números.", (value) =>
      /^[\d]+$/.test(value)
    ).max(
      10,
      "Por favor, verifique se a TN digitada possui até 10 caracteres."
    ),
  socialReason: Yup.string()
    .min(
      3,
      "Por favor, verifique se a razão social digitada possui entre 3 e 50 caracteres."
    )
    .max(
      50,
      "Por favor, verifique se a razão social digitada possui entre 3 e 50 caracteres."
    )
    .required("Para continuar é necessário preencher este campo."),
});

export const validationSchemaDriver = Yup.object({
  cnh: Yup.string()
    .required("Para continuar é necessário preencher este campo.")
    .test("onlyNumber", "Preencha somente com números.", (value) =>
      /^[\d]+$/.test(value)
    )
    .test(
      "min",
      "O número da CNH é composto por 11 números, verifique se inseriu corretamente.",
      (value) => String(value).length === 11
    ),
  expirationDate: Yup.date()
    .required("Para continuar é necessário preencher este campo.")
    .transform((_, originalValue) =>
      parse(originalValue, "dd/MM/yyyy", new Date()), 'Data Inválida'
    )
    .typeError('Data inválida, utilize dd/MM/aaaa ex: 30/05/2008'),
  toll: Yup.string()
    .required("Para continuar é necessário preencher este campo.")
    .test("onlyNumber", "Preencha somente com números.", (value) =>
      /^[\d]+$/.test(value)
    )
    .test(
      "minMax",
      "Caso esteja utilizando REPOM insira 8 caracteres, para Cartão Pedágio, insira 10 caracteres. Por favor, verifique as informações e tente novamente",
      (value) => String(value)?.length === 8 || String(value)?.length === 10
    ),
});
